/** Whether a per-field error map has anything in it. */
export const hasErrors = (errors: object): boolean => Object.keys(errors).length > 0;
